export const data = [
  {
    id: "educacion",
    icono: "GraduationCap",
    titulo: "Educación",
    candidatoA: {
      nombre: "Iván Cepeda",
      propuestaTitulo: "Derecho Universal y Pensamiento Crítico",
      puntos: [
        "Gratuidad total en educación pública superior.",
        "Creación de universidades físicas en territorios excluidos como la Amazonía y el Catatumbo.",
        "Dignificación salarial docente y currículos basados en investigación científica y memoria histórica."
      ]
    },
    candidatoB: {
      nombre: "Abelardo de la Espriella",
      propuestaTitulo: "Cuarta Revolución Industrial y Bilingüismo",
      puntos: [
        "Creación de la Universidad Virtual en Casa.",
        "Programas de ciclos cortos en inteligencia artificial, robótica y computación cuántica.",
        "Créditos blandos por mérito y evaluación docente obligatoria para medir calidad."
      ]
    },
    diferenciaClave: "Educación como derecho para reducir brechas sociales frente a educación orientada a la productividad tecnológica."
  },
  {
    id: "economia-y-desarrollo-rural",
    icono: "CircleDollarSign",
    titulo: "Economía y Desarrollo Rural",
    candidatoA: {
      nombre: "Iván Cepeda",
      propuestaTitulo: "Economía de la Vida y Revolución Agraria",
      puntos: [
        "Crecimiento basado en el fortalecimiento del mercado interno.",
        "El Estado como comprador directo de cosechas campesinas para eliminar intermediarios.",
        "Reforma urbana para vivienda digna y pública en cinturones de miseria.",
        "Redistribución de 1 millón de hectáreas y formalización masiva de tierras."
      ]
    },
    candidatoB: {
      nombre: "Abelardo de la Espriella",
      propuestaTitulo: "Crecimiento, Estado Reducido y Agroexportación",
      puntos: [
        "Meta de crecimiento del 7% anual inspirada en Singapur y Corea del Sur.",
        "Reducción del tamaño del Estado en un 25% y regla de 'una regulación entra, dos salen'.",
        "Programa País de Propietarios con tasas de interés del 2% a 30 años.",
        "Enfoque en agroindustria de exportación como palma y cereales."
      ]
    },
    diferenciaClave: "Un modelo prioriza mercado interno y redistribución de tierra; el otro apuesta por crecimiento acelerado, Estado más pequeño y agroexportación."
  },
  {
    id: "seguridad-y-narcotrafico",
    icono: "ShieldCheck",
    titulo: "Seguridad y Narcotráfico",
    candidatoA: {
      nombre: "Iván Cepeda",
      propuestaTitulo: "Seguridad Humana y Paz",
      puntos: [
        "Cambio de paradigma: pasar del prohibicionismo a un enfoque de salud pública y sustitución voluntaria.",
        "Protección de líderes sociales y cumplimiento estricto del Acuerdo de Paz de 2016.",
        "Diálogo para el fin del conflicto y desmilitarización de la respuesta a la protesta social."
      ]
    },
    candidatoB: {
      nombre: "Abelardo de la Espriella",
      propuestaTitulo: "Mano Dura contra el Crimen",
      puntos: [
        "Destrucción de 330.000 hectáreas de coca mediante fumigación aérea y erradicación manual.",
        "Creación de un Bloque de Búsqueda contra la extorsión y la 'Primera Línea' con reservistas.",
        "No habrá negociación con grupos criminales y se impulsará la extradición exprés."
      ]
    },
    diferenciaClave: "Diálogo, salud pública y seguridad humana frente a mano dura, erradicación forzada y cero negociación."
  },
  {
    id: "salud-y-bienestar-social",
    icono: "Stethoscope",
    titulo: "Salud y Bienestar Social",
    candidatoA: {
      nombre: "Iván Cepeda",
      propuestaTitulo: "Salud como Derecho",
      puntos: [
        "Reforma para eliminar la intermediación financiera de la Ley 100.",
        "Inversión directa en la red hospitalaria pública.",
        "Equipos básicos de salud preventiva que visitan hogares en zonas remotas."
      ]
    },
    candidatoB: {
      nombre: "Abelardo de la Espriella",
      propuestaTitulo: "EPS con Control y Modernización",
      puntos: [
        "Mantener las EPS con control estricto de los costos de administración.",
        "Plan de choque de 10 billones de pesos para sanear deudas del sistema.",
        "Telemedicina y tecnología para reducir tiempos de espera en citas de especialistas."
      ]
    },
    diferenciaClave: "Cepeda apuesta por quitar intermediación y fortalecer lo público; De la Espriella mantiene EPS con control de costos y modernización tecnológica."
  },
  {
    id: "corrupcion",
    icono: "Scale",
    titulo: "Lucha contra la Corrupción",
    candidatoA: {
      nombre: "Iván Cepeda",
      propuestaTitulo: "Sistema Nacional contra la Macrocorrupción",
      puntos: [
        "Creación de un sistema nacional con participación ciudadana.",
        "Austeridad republicana con reducción inmediata del sueldo del presidente y altos funcionarios."
      ]
    },
    candidatoB: {
      nombre: "Abelardo de la Espriella",
      propuestaTitulo: "Blockchain y Limpieza Institucional",
      puntos: [
        "Implementación de blockchain para 2030 en todas las contrataciones públicas.",
        "Limpieza inmediata de juntas directivas en instituciones como Ecopetrol."
      ]
    },
    diferenciaClave: "Participación ciudadana y austeridad estatal frente a tecnología anticorrupción y depuración institucional."
  },
  {
    id: "medio-ambiente-y-energia",
    icono: "Leaf",
    titulo: "Medio Ambiente y Energía",
    candidatoA: {
      nombre: "Iván Cepeda",
      propuestaTitulo: "Transición Energética Justa",
      puntos: [
        "Transición acelerada hacia fuentes limpias como solar y eólica.",
        "Prohibición del fracking.",
        "Derechos de la Madre Tierra y protección de páramos como fuentes de agua."
      ]
    },
    candidatoB: {
      nombre: "Abelardo de la Espriella",
      propuestaTitulo: "Hidrocarburos y Energía Nuclear",
      puntos: [
        "Defensa de los hidrocarburos como petróleo y gas.",
        "Exploración de energía nuclear.",
        "Desarrollo estratégico de minería de oro, cobre y tierras raras."
      ]
    },
    diferenciaClave: "Cepeda acelera la transición limpia y protege el agua; De la Espriella prioriza hidrocarburos, nuclear y minería estratégica."
  },
  {
    id: "inclusion-mujer-y-minorias",
    icono: "UsersRound",
    titulo: "Inclusión, Mujer y Minorías",
    candidatoA: {
      nombre: "Iván Cepeda",
      propuestaTitulo: "Sistema Nacional del Cuidado y Paridad",
      puntos: [
        "Sistema Nacional del Cuidado con pago a mujeres por labores de cuidado.",
        "Paridad de género en el gabinete.",
        "Rebelión antirracista y autonomía territorial para pueblos indígenas."
      ]
    },
    candidatoB: {
      nombre: "Abelardo de la Espriella",
      propuestaTitulo: "Emprendimiento, Justicia Rápida y Esterilización",
      puntos: [
        "Autonomía económica a través de 200.000 emprendimientos formalizados.",
        "Justicia penal en 72 horas para casos de violencia de género.",
        "Plan masivo de esterilización universal gratuita para animales."
      ]
    },
    diferenciaClave: "Cepeda centra la política social en cuidados, paridad y autonomía territorial; De la Espriella en emprendimiento, respuesta penal rápida y control poblacional animal."
  }
];

/** Indicadores de opinión pública — segunda vuelta presidencial Colombia 2026 */
export const estadisticasElectorado = {
  preocupaciones: [
    { id: 'corrupcion', label: 'Corrupción', value: 84, color: 'bg-slate-800' },
    { id: 'costo-vida', label: 'Costo de vida', value: 81, color: 'bg-amber-500' },
    { id: 'seguridad', label: 'Seguridad', value: 75, color: 'bg-indigo-500' },
    { id: 'salud', label: 'Salud', value: 68, color: 'bg-emerald-500' }
  ],
  tendencias: [
    { id: 'voto-blanco', label: 'Intención de voto en blanco', value: 14, color: 'bg-slate-400' },
    { id: 'indecisos', label: 'Indecisos', value: 18, color: 'bg-indigo-400' }
  ],
  fuente:
    'Síntesis de encuestas y sondeos de opinión sobre prioridades del electorado en la recta final de la campaña presidencial 2026.'
};

export const articulos = [
  {
    id: 'analisis-lsv-1',
    titulo: 'Colombia va a una segunda vuelta entre dos proyectos excluyentes',
    fuente: 'La Silla Vacía',
    imagen: 'https://images.unsplash.com/photo-1529107386315-e2a866aed77a?auto=format&fit=crop&w=1200&q=80',
    url: 'https://www.lasillavacia.com/silla-nacional/colombia-va-a-una-segunda-vuelta-entre-dos-proyectos-excluyentes/',
    resumen:
      'Análisis de la polarización entre Cepeda y De la Espriella: dos visiones de país planteadas como amenazas existenciales y la pelea por convertir el rechazo al rival en mayoría.'
  },
  {
    id: 'analisis-lsv-2',
    titulo: 'El primer tiempo de la segunda vuelta',
    fuente: 'La Silla Vacía',
    imagen: 'https://images.unsplash.com/photo-1541872703-74c5ecc2c6a8?auto=format&fit=crop&w=1200&q=80',
    url: 'https://www.lasillavacia.com/opinion/el-primer-tiempo-de-la-segunda-vuelta/',
    resumen:
      'La primera vuelta anticipó un balotaje sin tercero en contienda: De la Espriella adelante, Cepeda con techo electoral similar al petrismo de 2022 y tres semanas de campaña por el centro.'
  },
  {
    id: 'analisis-espectador-1',
    titulo:
      'Elecciones 2026: los resultados de Cepeda y De la Espriella reviven la polarización del plebiscito de 2016',
    fuente: 'El Espectador',
    imagen: 'https://images.unsplash.com/photo-1464226184884-fa280b87c399?auto=format&fit=crop&w=1200&q=80',
    url: 'https://www.elespectador.com/colombia-20/paz-y-memoria/elecciones-2026-resultados-de-cepeda-y-de-la-espriella-en-primera-vuelta-se-parecen-a-plebiscito-y-polarizacion-de-2016/',
    resumen:
      'El mapa electoral de la primera vuelta evoca la división del plebiscito por la paz; expertos señalan el regreso de brechas profundas en seguridad y salud.'
  }
];

export const videos = [
  {
    id: 'video-cepeda-pronunciamiento',
    titulo: 'Iván Cepeda se pronuncia tras los resultados de la primera vuelta',
    fuente: 'YouTube · Noticias RCN',
    youtubeId: '-k5-WmKJ7mQ',
    thumbnail: 'https://img.youtube.com/vi/-k5-WmKJ7mQ/hqdefault.jpg',
    url: 'https://www.youtube.com/embed/-k5-WmKJ7mQ',
    descripcion:
      'Discurso del candidato del Pacto Histórico la noche del 31 de mayo, en vísperas del balotaje del 21 de junio.'
  },
  {
    id: 'video-espriella-entrevista-red',
    titulo: 'Abelardo De la Espriella identifica a su "único enemigo"',
    fuente: 'YouTube · RED+ Noticias',
    youtubeId: 'lmjp-gpeSdc',
    thumbnail: 'https://img.youtube.com/vi/lmjp-gpeSdc/hqdefault.jpg',
    url: 'https://www.youtube.com/embed/lmjp-gpeSdc',
    descripcion:
      'Entrevista en campaña sobre la segunda vuelta, la derecha unificada y el duelo con Iván Cepeda.'
  },
  {
    id: 'video-espriella-formula-rcn',
    titulo: 'Abelardo de la Espriella y su fórmula: visión de país para Colombia',
    fuente: 'YouTube · Noticias RCN',
    youtubeId: 'm3fQLndeuHU',
    thumbnail: 'https://img.youtube.com/vi/m3fQLndeuHU/hqdefault.jpg',
    url: 'https://www.youtube.com/embed/m3fQLndeuHU',
    descripcion:
      'Conversación con José Manuel Restrepo sobre propuestas y el perfil del binomio de Defensores de la Patria.'
  },
  {
    id: 'video-espectador-analisis',
    titulo: '¿Por qué ganó De la Espriella y qué debe hacer Iván Cepeda?',
    fuente: 'YouTube · El Espectador',
    youtubeId: 'KCfnhHrbAF8',
    thumbnail: 'https://img.youtube.com/vi/KCfnhHrbAF8/hqdefault.jpg',
    url: 'https://www.youtube.com/embed/KCfnhHrbAF8',
    descripcion:
      'Mesa de análisis del equipo político de El Espectador sobre el resultado de la primera vuelta y la recta final.'
  }
];
